import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  FAQ: {
    path: `${baseRoutes.userBaseRoutes}faq`,
  },
  PRIVACY_POLICY: {
    path: `${baseRoutes.userBaseRoutes}privacy-policy`,
  },
  Terms_And_Condition: {
    path: `${baseRoutes.userBaseRoutes}terms-and-condition`,
  },
  LOGIN: {
    path: `${baseRoutes.userBaseRoutes}login`,
  },
  SIGNUP: {
    path: `${baseRoutes.userBaseRoutes}signup`,
  },
  FORGOT_PASSWORD: {
    path: `${baseRoutes.userBaseRoutes}forgot-password`,
  },
  RESET_PASSWORD: {
    path: `${baseRoutes.userBaseRoutes}/reset-password`,
  },
  OTP_VERIFICATION: {
    path: `${baseRoutes.userBaseRoutes}otp-verification`,
  },
  DELETE_ACCOUNT: {
    path: `${baseRoutes.userBaseRoutes}delete-account`,
  },
  VERIFY_EMAIL: {
    path: `${baseRoutes.userBaseRoutes}verify-email`,
  },
  DELETE_ACCOUNT_REQUEST: {
    path: `${baseRoutes.userBaseRoutes}delete-account-request`,
  },
};

export default accessRoute;
